import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@freelancer/directives';
import { UiModule } from '@freelancer/ui';
import { AutoCompleteRichTextComponent } from './auto-complete-rich-text/auto-complete-rich-text.component';
import {
  AutoCompleteComponent,
  AutoCompleteInputComponent,
  AutoCompleteSuggestionTemplateComponent,
} from './auto-complete.component';
import { LoadingTextComponent } from '../loading-text';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    UiModule,
    AutoCompleteRichTextComponent,
    LoadingTextComponent,
  ],
  declarations: [
    AutoCompleteComponent,
    AutoCompleteInputComponent,
    AutoCompleteSuggestionTemplateComponent,
  ],
  exports: [
    AutoCompleteComponent,
    AutoCompleteInputComponent,
    AutoCompleteRichTextComponent,
    AutoCompleteSuggestionTemplateComponent,
  ],
})
export class AutoCompleteModule {}
